import { RefObject, useLayoutEffect } from "react";

/**
 * Side by side (lg), an order summary stays at the spot it starts in while the content next to it scrolls past.
 * That spot is measured from the page and exposed as `--order-summary-top` so it follows header height changes.
 */
export function useStickySummaryTop(ref: RefObject<HTMLElement>, remeasureKey?: unknown) {
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const pinAtStartPosition = () => {
      element.style.top = "auto";
      const startTop = element.getBoundingClientRect().top + window.scrollY;
      element.style.top = "";
      element.style.setProperty("--order-summary-top", `${Math.max(0, startTop)}px`);
    };
    pinAtStartPosition();
    const observer = new ResizeObserver(pinAtStartPosition);
    observer.observe(document.body);
    window.addEventListener("resize", pinAtStartPosition);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", pinAtStartPosition);
    };
  }, [ref, remeasureKey]);
}
